import { GlIcon } from '@gitlab/ui';
import TimelineEntryItem from '~/vue_shared/components/notes/timeline_entry_item.vue';
export default {
    name: 'HistoryItem',
    components: {
        GlIcon,
        TimelineEntryItem
    },
    props: {
        icon: {
            type: String,
            required: true
        }
    }
};
